import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Button, Table, Modal, ButtonGroup } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export default class ListaAdjuntos extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  abre_documento = (url_doc) => {
    window.open(url_doc, "_blank")
  };

  render() {
    const { } = this.state;

    let archivos = this.props.archivos.map((el) => {
      const url_doc =
        "http://143.198.191.211/api/securedocs/" +
        el.filename +
        "?api_token=" +
        localStorage.api_token;
      return (
        <tr key={el.id}>
          <td>
            <a href={url_doc} target="_blank">
              {el.descripcion}
            </a>
          </td>
          <td>
            <ButtonGroup size="sm">
              <button
                type="button"
                className="btn btn-outline-info btn-sm"
                size="sm"
                onClick={() => this.abre_documento(url_doc)}
                data-tip="Visualizar"
              >
                <FontAwesomeIcon icon={faEye} size="lg" />
              </button>
            </ButtonGroup>
          </td>
        </tr>
      );
    });

    return (
      <div>
        <Table bordered size="sm" className="tabla-perfil">
          <thead>
            <tr>
              <th>Descripción</th>
              <th style={{ width: "42px" }}></th>
            </tr>
          </thead>
          <tbody>
            {archivos}
          </tbody>
        </Table>
        <br></br>
      </div>
    );
  }
}
